import { Link } from 'react-router-dom';

const bgImageUrl = 'https://readdy.ai/api/search-image?query=Abstract%20elegant%20flowing%20composition%20with%20warm%20amber%20and%20golden%20tones%2C%20soft%20layered%20geometric%20shapes%2C%20minimalist%20sophisticated%20design%2C%20subtle%20luminous%20gradients%2C%20clean%20modern%20aesthetic%2C%20editorial%20background%20texture%20with%20gentle%20light%20transitions%2C%20warm%20radiant%20center%20glow%2C%20refined%20premium%20atmosphere%2C%20no%20text&width=1200&height=500&seq=vigorbuy-cta-2026-v3&orientation=landscape';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-background-900">
          <div
            className="absolute inset-0 opacity-20 bg-cover bg-center"
            style={{
              backgroundImage: `url('${bgImageUrl}')`,
            }}
          />

          <div className="relative z-10 text-center px-4 md:px-6 py-12 md:py-16">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
              Explore VigorBuy Spreadsheet Today
            </h2>
            <p className="text-sm md:text-base text-background-300 max-w-[500px] mx-auto mb-8">
              Discover updated guides, tutorials, and trusted resources to make smarter purchases.
              Start browsing our curated categories now.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold whitespace-nowrap rounded-md bg-primary-500 text-background-50 hover:bg-primary-400 transition-colors cursor-pointer"
              >
                VigorBuy Sheet
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold whitespace-nowrap rounded-md bg-background-50/10 text-background-50 border border-background-50/30 hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                Buy It Now
                <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <Link
                to="/vigorbuy-buying-guide/"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium whitespace-nowrap rounded-md text-background-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                Read Complete Guide
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}